import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('./views/pages/HomePage.vue'),
    meta: {
      title: 'Home',
    },
  },
];
